import templateOnly from '@ember/component/template-only';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if @current_users.length}}\n  <div>\n    <div class=\'sb-card__title\'>\n      {{t \'open by\'}}\n    </div>\n    <div class=\'current-users-list\'>\n      {{#each @current_users as |c|}}\n        <div class=\'current-users-item\'>{{c.label}}</div>\n      {{/each}}\n    </div>\n  </div>\n{{/if}}");

var bbPresenceList = setComponentTemplate(TEMPLATE, templateOnly());

export { bbPresenceList as default };
//# sourceMappingURL=bb-presence-list.js.map
